import { z } from "zod";
import {
  API_PREFIX,
  paginatedFromDto,
  paginationMetaDtoSchema,
  type HttpClient,
} from "@nasam/kernel";
import type { CountriesRepository } from "../domain";
import { countryFromDto, governorateFromDto } from "./organizationMappers";
import { countryDtoSchema, governorateDtoSchema } from "./organizationDtos";

const countryListResponseDtoSchema = z.object({
  data: z.array(countryDtoSchema),
  meta: paginationMetaDtoSchema,
});

const governorateListResponseDtoSchema = z.object({
  data: z.array(governorateDtoSchema),
  meta: paginationMetaDtoSchema,
});

export function createCountriesHttpRepository(
  http: HttpClient,
): CountriesRepository {
  return {
    async list(query) {
      const response = await http.get(`${API_PREFIX}/countries`, {
        params: query,
      });
      return paginatedFromDto(
        countryListResponseDtoSchema.parse(response),
        countryFromDto,
      );
    },

    async listGovernorates(countryId, query) {
      const response = await http.get(
        `${API_PREFIX}/countries/${countryId}/governorates`,
        { params: query },
      );
      return paginatedFromDto(
        governorateListResponseDtoSchema.parse(response),
        governorateFromDto,
      );
    },
  };
}
